import {shouldForwardProp, chakra} from '@chakra-ui/react';
import {motion, isValidMotionProp} from 'framer-motion';

export const MotionBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});
